import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Directory from "@/pages/Directory";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLeads from "@/pages/AdminLeads";
import ShowPage from "@/pages/ShowPage";

function App() {
  return (
    <div className="App grain">
      <HelmetProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Directory />} />
            <Route path="/previous-shows" element={<Directory archived />} />
            <Route path="/show/:id" element={<ShowPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin" element={<AdminLeads />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
